
import moment from "moment";
import {
  setStartDate,
  setEndDate,
  REQUEST_STARTED,
  REQUEST_COMPLETED,
} from "../../../redux/action";
import { connect, ConnectedProps, useDispatch } from "react-redux";
import { RootState } from "../../../redux/reducer";
import React, { useMemo, useState } from "react";
import { downloadCSV } from "../../kayJwellers/helper";
import { AgGridReact } from "ag-grid-react"; // the AG Grid React Component
// import "ag-grid-community/dist/styles/ag-grid.css"; // Core grid CSS, always needed
// import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import 'ag-grid-community/styles/ag-grid.css';
import "ag-grid-community/styles/ag-theme-alpine.css";
import axios from "axios";
import { Button, Grid, TextField } from "@mui/material";
import { DatePicker, LocalizationProvider, TimePicker } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import dayjs from "dayjs";

type PropsFromRedux = ConnectedProps<typeof connector>;
type VisulDemographicTabProps = PropsFromRedux & {};

const VisualDemographicTab: React.FC<VisulDemographicTabProps> = ({
  startDateObj,
  endDateObj,
  setStartDate,
  setEndDate,
}) => {
  const columnDefs = [
    {
      field: "record_id",
      headerName: "RECORD ID",
    },
    {
      field: "store_name",
      headerName: "STORE_NAME",
    },
    {
      field: "store_id",
      headerName: "STORE_ID",
    },
    {
      field: "date",
      headerName: "DATE",
    },
    {
      field: "time",
      headerName: "TIME",
    },
    {
      field: "fd_dwell_time",
      headerName: "FD DWELL TIME",
    },

    {
      field: "demographic",
      headerName: "DEMOGRAPHIC",
    },
    {
      field: "traffic",
      headerName: "TRAFFIC",
    },
    {
      field: "impression",
      headerName: "IMPRESSION",
    },
    {
      field: "engagement",
      headerName: "ENGAGEMENT",
    },
    {
      field: "abandonment",
      headerName: "ABANDONMENT",
    },
    {
      field: "fd_mood",
      headerName: "FD MOOD",
    },
    {
      field: "fd_proximity",
      headerName: "FD_PROXIMITY",
    },
    {
      field: "fd_age_group",
      headerName: "FD AGE GROUP",
    },
    {
      field: "fd_gender",
      headerName: "FD GENDER",
    },
    {
      field: "store_type",
      headerName: "STORE_TYPE",
    },
    {
      field: "banner_name",
      headerName: "BANNER_NAME",
    },
    {
      field: "store_location",
      headerName: "STORE_LOCATION",
    },
    {
      field: "installation_date",
      headerName: "INSTALLATION_DATE",
    },
    {
      field: "device_placement_Easels",
      headerName: "DEVICE_PLACEMENT_EASELS",
    },
    {
      field: "device_position_Easels",
      headerName: "DEVICE_POSITION_EASELS",
    },
    {
      field: "city",
      headerName: "CITY",
    },
    {
      field: "state",
      headerName: "STATE",
    },
  ];
  const defaultColDef = useMemo(() => {
    return {
      sortable: true,
      resizable: true,
    };
  }, []);

  //const classes = useStyles();
  const dispatch = useDispatch();
  const [startTime, setStartTime] = useState(startDateObj);
  const [endTime, setEndTime] = useState(startDateObj);
  const [fdStart, setFDStart] = useState(0);
  const [fdEnd, setFDEnd] = useState(275);
  const [disabled, setDisabled] = useState(true);
  const [tbody, setTbody] = useState<any[]>([]);

  const handleFromDateChange = (date: any) => {
    setStartDate(date.$d);
  };

  const handleToDateChange = (date: any) => {
    setEndDate(date.$d);
  };

  const handleStartTimeChange = (time: any) => {
    console.log("Time", time.$d)
    setStartTime(time.$d);
  };
  const handleEndTimeChange = (time: any) => {
    setEndTime(time.$d);
  };

  const startdate = moment(startDateObj).format("YYYY-MM-DD");
  const enddate = moment(endDateObj).format("YYYY-MM-DD");
  const starttime = moment(startTime).format("HH:mm:ss");
  const endtime = moment(endTime).format("HH:mm:ss");
  let startDateTime: any = startdate + starttime;
  let endDateTime: any = enddate + endtime;
  startDateTime = moment(startDateTime, "YYYY-MM-DD HH:mm");
  endDateTime = moment(endDateTime, "YYYY-MM-DD HH:mm");
  function getData() {
    if (startDateTime <= endDateTime && startTime <= endTime) {
      dispatch({ type: REQUEST_STARTED });
      console.time();
      axios
        .get(
          `https://api.virtualvisions.io/visualdemographic?startDate=${startdate}&endDate=${enddate}&startTime=${starttime}&endTime=${endtime}&minProximity=${fdStart}&maxProximity=${fdEnd}`
        )
        .then((data) => {
          setTbody(data.data);
          setDisabled(false);
          dispatch({ type: REQUEST_COMPLETED });
          console.timeEnd();
        })
        .catch((err) => {
          console.log("getting error in Api", err);
          alert(err);
        });
    } else {
      let message = "";
      message =
        startDateTime >= endDateTime
          ? (message = "Start date should be less than end date")
          : "Start time should be less than end end";
      alert(message);
    }
  }
  function getCvsData() {
    window.open(
      `https://api.virtualvisions.io/visualdemographic/download?startDate=${startdate}&endDate=${enddate}&startTime=${starttime}&endTime=${endtime}&minProximity=${fdStart}&maxProximity=${fdEnd}`
    );
  }

  return (
    <>
      <div style={{marginTop:30, display:'flex', flexDirection:'column', justifyContent:'flex-start',}}>
        <div>
      <LocalizationProvider dateAdapter={AdapterDayjs} >
      <Grid container spacing={3}>
            <Grid item xs={12} lg={6}>
            <DatePicker
label="From Date"
format="MM/DD/YYYY"
value={dayjs(startDateObj)}
sx={{marginRight:'10px'}}
onChange={handleFromDateChange}
/>

<DatePicker
label="To Date"
format="MM/DD/YYYY"
value={dayjs(endDateObj)}
sx={{marginRight:'10px'}}
onChange={handleToDateChange}
/>
</Grid>
<Grid item xs={12}>
<TimePicker
  label="Start Time"
  ampm={false}
  value={dayjs(startTime)}
  onChange={handleStartTimeChange}
/>
<TimePicker
sx={{marginLeft:1.3}}
  label="End Time"
  ampm={false}
  value={dayjs(endTime)}
  onChange={handleEndTimeChange}
/>
</Grid>
<Grid item xs={12}>
<TextField
                sx={{ width:230 }}
                id="standard-number"
                label="FD Proximity Start"
                type="number"
                 InputLabelProps={{
                  shrink: true,
                }}
                placeholder="0"
                onChange={(e: any) => setFDStart(e.target.value)}
              />
              <TextField
                style={{ marginLeft: 10 ,width:230 }}
                id="standard-number"
                label="FD Proximity End"
                type="number"
               InputLabelProps={{
                  shrink: true,
                }}
                placeholder="275"
                onChange={(e: any) => setFDEnd(e.target.value)}
              />
</Grid>
</Grid>
      </LocalizationProvider>
        </div>

        {/* <MuiPickersUtilsProvider utils={DateFnsUtils}>
          <Grid container spacing={3}>
            <Grid item xs={12} lg={6}>
              <KeyboardDatePicker
                style={{ marginLeft: 16 }}
                margin="normal"
                id="date-picker-dialog"
                label="From Date"
           1     format="MM/dd/yyyy"
                value={startDateObj}
                onChange={handleFromDateChange}
                KeyboardButtonProps={{
                  "aria-label": "change date",
                }}
                autoOk={true}
              />
              <KeyboardDatePicker
                style={{ marginLeft: 16 }}
                margin="normal"
                id="date-picker-dialog"
                label="To Date"
          2      format="MM/dd/yyyy"
                value={endDateObj}
                onChange={handleToDateChange}
                KeyboardButtonProps={{
                  "aria-label": "change date",
                }}
                autoOk={true}
              />
            </Grid>
            <Grid item xs={12}>
              <KeyboardTimePicker
                style={{ marginLeft: 16 }}
                margin="normal"
                id="time-picker"
                label="Start Time"
           3     ampm={false}
                value={startTime}
                onChange={handleStartTimeChange}
                KeyboardButtonProps={{
                  "aria-label": "change time",
                }}
              />
              <KeyboardTimePicker
                style={{ marginLeft: 16 }}
                margin="normal"
                id="time-picker"
                label="End Time"
           4     ampm={false}
                value={endTime}
                onChange={handleEndTimeChange}
                KeyboardButtonProps={{
                  "aria-label": "change time",
                }}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                style={{ marginLeft: 16 }}
                id="standard-number"
                label="FD Proximity Start"
                type="number"
            5    InputLabelProps={{
                  shrink: true,
                }}
                placeholder="0"
                onChange={(e: any) => setFDStart(e.target.value)}
              />
              <TextField
                style={{ marginLeft: 16 }}
                id="standard-number"
                label="FD Proximity End"
                type="number"
           6     InputLabelProps={{
                  shrink: true,
                }}
                placeholder="275"
                onChange={(e: any) => setFDEnd(e.target.value)}
              />
            </Grid>
          </Grid>
        </MuiPickersUtilsProvider> */}
        <div style={{ display: "flex", flexDirection:'row', justifyContent:'flex-start', alignItems:'center', paddingTop:20}}>
          <Button
            variant="contained"
            color="secondary"
            sx={{
              height: 40,
              width: 230,
              marginRight:1.5
            }}
            onClick={getData}>
            Apply
          </Button>
          <Button
            id="CSV"
            // disabled={disabled}
            color="primary"
            variant="contained"
            sx={{
              fontSize: 12,
              textAlign: "center",
              paddingTop:1.3,
            paddingBottom:1.3,
            height:40,
            width:230
            }}
            onClick={getCvsData}
            // onClick={() =>
            //   // downloadCSV(tbody, "visual_demographic", columnDefs)
          >
            {" "}
            Download CSV
          </Button>
        </div>
      </div>
      <div>
        <p
          style={{
            textAlign: "center",
            textTransform: "uppercase",
            color: "#009688",
          }}>
          We are showing Top 1000 Records In Table For All Records Please
          Download File.
        </p>
      </div>
      {tbody && (
        <div
          className="ag-theme-alpine"
          style={{ width: "100%", height: 800, marginTop: "16px" }}>
          <AgGridReact
            rowData={tbody} // Row Data for Rows
            columnDefs={columnDefs} // Column Defs for Columns
            animateRows={true} // Optional - set to 'true' to have rows animate when sorted
            pagination={true}
            defaultColDef={defaultColDef}
            paginationPageSize={100}
          />
        </div>
      )}
    </>
  );
};

const mapState = (state: RootState) => ({
  isUserLoggedIn: state.user.isUserLoggedIn,
  startDateObj: state.report.startDate,
  endDateObj: state.report.endDate,
  dateRange: state.report.dateRange,
});

const connector = connect(mapState, {
  setStartDate,
  setEndDate,
});

export default connector(VisualDemographicTab);
